export default __webpack_public_path__ + "static/outcome-cb57f283ecd61a5f4ac98c6255f3dd02.jpg";